(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gbc-enquiry-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var form = root.querySelector('.gbc-eq__form'), done = root.querySelector('.gbc-eq__done');
    var btn = root.querySelector('.gbc-eq__submit'), fail = root.querySelector('.gbc-eq__fail');
    var sel = form.querySelector('[name="bundle"]');
    var KEY = root.dataset.key, LIST = root.dataset.list, MODE = root.dataset.mode;
    var REV = '2024-10-15', API = 'https://a.klaviyo.com/client/';

    function pick(key) { if (!key || !sel) return; for (var i = 0; i < sel.options.length; i++) if (sel.options[i].dataset.key === key) { sel.selectedIndex = i; return; } }
    pick(new URLSearchParams(location.search).get('bundle'));
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-bundle]'); if (!a) return;
      e.preventDefault(); pick(a.getAttribute('data-bundle'));
      if (!done.hidden) { done.hidden = true; form.hidden = false; }
      window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
      setTimeout(function () { form.querySelector('[name="name"]').focus({ preventScroll: true }); }, 600);
    });

    function validate() {
      var ok = true;
      ['name', 'company', 'email', 'message'].forEach(function (n) {
        var el = form.elements[n], v = el.value.trim();
        var bad = !v || (n === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v));
        el.classList.toggle('is-invalid', bad); el.setAttribute('aria-invalid', bad ? 'true' : 'false'); el.closest('.gbc-eq__field').classList.toggle('has-error', bad);
        if (bad && ok) { el.focus(); ok = false; }
      });
      return ok;
    }
    form.addEventListener('input', function (e) { var f = e.target.closest('.gbc-eq__field'); if (f) { f.classList.remove('has-error'); e.target.classList.remove('is-invalid'); e.target.setAttribute('aria-invalid', 'false'); } });

    function post(path, data) {
      return fetch(API + path + '/?company_id=' + encodeURIComponent(KEY), {
        method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REV }, body: JSON.stringify({ data: data })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault(); fail.hidden = true;
      if (!validate()) return;
      if (!KEY) { console.warn('GBC enquiry: add your Klaviyo public API key in the section settings.'); fail.hidden = false; return; }
      var v = function (n) { return form.elements[n] ? form.elements[n].value.trim() : ''; };
      var name = v('name').split(/\s+/), email = v('email').toLowerCase();
      var digits = v('phone').replace(/\D/g, '').replace(/^(00971|971)/, '').replace(/^0/, '');
      var phoneE164 = /^5\d{8}$/.test(digits) ? '+971' + digits : null;
      var props = { 'Company': v('company'), 'Corporate bundle': v('bundle'), 'Corporate quantity': v('quantity'), 'Corporate message': v('message'),
        'Phone (entered)': v('phone'), 'Lead source': root.dataset.source, 'Page': location.href };
      var attrs = { email: email, first_name: name[0], last_name: name.slice(1).join(' ') || undefined, organization: v('company'),
        properties: { 'Corporate lead': true, 'Corporate bundle': v('bundle'), 'Corporate quantity': v('quantity') } };
      if (phoneE164) attrs.phone_number = phoneE164;

      btn.disabled = true;
      var jobs = [post('events', { type: 'event', attributes: {
        properties: props,
        metric: { data: { type: 'metric', attributes: { name: root.dataset.metric || 'Corporate Enquiry Submitted' } } },
        profile: { data: { type: 'profile', attributes: attrs } }
      } })];
      var consent = form.elements.consent ? form.elements.consent.checked : MODE !== 'consent';
      if (LIST && (MODE === 'always' || (MODE === 'consent' && consent))) {
        jobs.push(post('subscriptions', { type: 'subscription', attributes: {
          custom_source: root.dataset.source,
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }, relationships: { list: { data: { type: 'list', id: LIST } } } }).catch(function (err) { console.warn('GBC enquiry: list signup failed', err); }));
      }
      Promise.all(jobs).then(function () {
        form.reset(); form.hidden = true; done.hidden = false;
        window.dispatchEvent(new CustomEvent('gbc:enquiry', { detail: props }));
      }).catch(function () { fail.hidden = false; }).finally(function () { btn.disabled = false; });
    });
    root.querySelector('.gbc-eq__again').addEventListener('click', function () { done.hidden = true; form.hidden = false; });
  }
  function boot() { document.querySelectorAll('.gbc-eq').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
